export const SET_OPEN_SIDEBAR = 'uiEffects/SET_OPEN_SIDEBAR';
export const SET_CONNECTION_LOST = 'uiEffects/SET_CONNECTION_LOST';
